import { render, staticRenderFns } from "./TabelaNaoEnviadosRelatorioRastreabilidade.vue?vue&type=template&id=0823c244&lang=pug"
import script from "./TabelaNaoEnviadosRelatorioRastreabilidade.vue?vue&type=script&lang=js"
export * from "./TabelaNaoEnviadosRelatorioRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./TabelaNaoEnviadosRelatorioRastreabilidade.vue?vue&type=style&index=0&id=0823c244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports